import { c as _c } from "react/compiler-runtime";
import { NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
import { MarkupsBoardAvatar } from "@pages/project-details/project-markups/board/markups-board-avatar";
import { MarkupsBoardDueDateChip } from "@pages/project-details/project-markups/board/markups-board-due-date-chip";
import { MarkupsBoardTags } from "@pages/project-details/project-markups/board/markups-board-tags";
import { SELECTED_MARKUP_BACKGROUND } from "@pages/project-details/project-markups/markup-selection-styles";
/** Opacity of a card while its new status is saved */
const PENDING_CARD_OPACITY = 0.6;
/** Card of a markup in the board, with its title, tags, due date and assignee */
export function ProjectMarkupsBoardCard(t0) {
  const $ = _c(38);
  const {
    markup,
    assignee,
    dueDateUrgency,
    isSelected,
    isDraggable,
    isPending,
    onClick,
    onDragStart,
    onDragEnd
  } = t0;
  let t1;
  if ($[0] !== markup || $[1] !== onDragStart) {
    t1 = function handleDragStart(event) {
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", markup.id);
      onDragStart(markup);
    };
    $[0] = markup;
    $[1] = onDragStart;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDragStart = t1;
  let t2;
  if ($[3] !== markup || $[4] !== onClick) {
    t2 = function handleKeyDown(event_0) {
      if (event_0.key === "Enter" || event_0.key === " ") {
        event_0.preventDefault();
        onClick(markup);
      }
    };
    $[3] = markup;
    $[4] = onClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleKeyDown = t2;
  const t3 = isSelected || undefined;
  let t4;
  if ($[6] !== markup || $[7] !== onClick) {
    t4 = () => onClick(markup);
    $[6] = markup;
    $[7] = onClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isSelected ? "primary.main" : "divider";
  const t6 = isSelected ? SELECTED_MARKUP_BACKGROUND : "background.paper";
  const t7 = isDraggable ? "grab" : "pointer";
  const t8 = isPending ? PENDING_CARD_OPACITY : 1;
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      borderColor: "primary.main"
    };
    t10 = {
      outline: 2,
      outlineColor: "primary.main"
    };
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t11 = {
      flexShrink: 0,
      scrollMarginTop: "3.5rem",
      gap: 1,
      p: 1.5,
      borderRadius: 1,
      border: 1,
      borderColor: t5,
      backgroundColor: t6,
      cursor: t7,
      opacity: t8,
      "&:hover": t9,
      "&:focus-visible": t10
    };
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      display: "-webkit-box",
      WebkitLineClamp: 3,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      overflowWrap: "anywhere"
    };
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== markup.name) {
    t13 = <Text variant="bodyM" sx={t12}>{markup.name}</Text>;
    $[17] = markup.name;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== markup.labels) {
    t14 = !!markup.labels?.length && <MarkupsBoardTags tags={markup.labels} />;
    $[19] = markup.labels;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== assignee || $[22] !== dueDateUrgency || $[23] !== markup) {
    t15 = (markup.dueDate || assignee) && <Stack direction="row" sx={{
      alignItems: "center",
      gap: 1
    }}><MarkupsBoardDueDateChip markup={markup} urgency={dueDateUrgency} />{assignee && <Box sx={{
        display: "flex",
        flexShrink: 0,
        ml: "auto"
      }}><MarkupsBoardAvatar assignee={assignee} /></Box>}</Stack>;
    $[21] = assignee;
    $[22] = dueDateUrgency;
    $[23] = markup;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== handleDragStart || $[26] !== handleKeyDown || $[27] !== isDraggable || $[28] !== isPending || $[29] !== markup.id || $[30] !== onDragEnd || $[31] !== t11 || $[32] !== t13 || $[33] !== t14 || $[34] !== t15 || $[35] !== t3 || $[36] !== t4) {
    t16 = <Stack role="button" tabIndex={0} draggable={isDraggable} aria-busy={isPending} aria-current={t3} data-markup-id={markup.id} className={NO_TRANSLATE_CLASS} onClick={t4} onKeyDown={handleKeyDown} onDragStart={handleDragStart} onDragEnd={onDragEnd} sx={t11}>{t13}{t14}{t15}</Stack>;
    $[25] = handleDragStart;
    $[26] = handleKeyDown;
    $[27] = isDraggable;
    $[28] = isPending;
    $[29] = markup.id;
    $[30] = onDragEnd;
    $[31] = t11;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t3;
    $[36] = t4;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}